// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sound"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.0002 21L5.99902 16.5V7.5L14.0002 3V21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 16.5L2 7.5H5.99882L5.99882 16.5L2 16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.99882 16.5L2 16.5L2 7.5H5.99882M5.99882 16.5L14 21V3L5.99882 7.5M5.99882 16.5L5.99882 7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.9902 13.5059C18.3184 13.0719 18.4961 12.5428 18.4963 11.9987C18.4965 11.4546 18.3192 10.9254 17.9913 10.4912M20.7813 15.618C21.5689 14.5765 21.9953 13.3066 21.9957 12.0008C21.9962 10.6951 21.5707 9.42481 20.7838 8.38281","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SoundIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound',
    ref,
    icon: element,
  },
));

SoundIcon.displayName = 'SoundIcon';

export default SoundIcon;
